var module = angular.module('octopusApp.configuration');

module.controller('ServerEditController', function($scope, $q, $location, busy, octopusRepository, unsavedChanges, $window) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.status = { 
        ready: false 
    };

    $scope.saveServerConfiguration = function() {
        isSaving.promise(octopusRepository.ServerConfiguration.modify($scope.config).then(function(config) {
            $scope.config = config;
            unsavedChanges.saved();
        }));
    };

    function init() {
        isLoading.promise(octopusRepository.ServerConfiguration.get().then(function (config) {
            $scope.config = config;
        }));

        isLoading.promise(octopusRepository.ServerConfiguration.settings().then(function (configSettings) {
            $scope.configSettings = configSettings;
        }));
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/nodes/config/controllers/server_edit_controller.js
// module id = 5413540036973336
// module chunks = 1